import { useEffect, useRef, useState } from 'react';
import { useReactToPrint } from 'react-to-print';

interface UsePrintRowsOptions {
  documentTitle: string;
  hasSelection: boolean;
}

export const usePrintRows = ({ documentTitle, hasSelection }: UsePrintRowsOptions) => {
  const printRef = useRef<HTMLDivElement>(null);
  const [printingSelection, setPrintingSelection] = useState(false);
  const resolveRef = useRef<(() => void) | null>(null);

  useEffect(() => {
    if (!printingSelection || !resolveRef.current) return;
    resolveRef.current();
    resolveRef.current = null;
  }, [printingSelection]);

  const print = useReactToPrint({
    content: () => printRef.current,
    documentTitle,
    onBeforeGetContent: () =>
      new Promise<void>((resolve) => {
        if (!hasSelection) {
          resolve();
          return;
        }
        resolveRef.current = resolve;
        setPrintingSelection(true);
      }),
    onAfterPrint: () => setPrintingSelection(false),
  });

  return { printRef, printingSelection, print };
};

export default usePrintRows;
